import {
  Button,
  Card,
  Col,
  Input,
  Pagination,
  Row,
  Spin,
  Table,
  Select,
  message,
  Popconfirm,
  Modal
} from "antd";
import { LoadingOutlined, DownloadOutlined, DeleteOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import {
  EXPORT_DOWNLOAD_REPORT,
  LIST_OFFENDER_REPORT,
  DELETE_CAMPAIGN_OFFENDER_REPORT
} from "../../../apis/apis";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import { formatToIST } from "../../../../helper/CommonHelper";

const { Option } = Select;

function OffenderDownload() {
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);

  const [table_data, set_table_data] = useState([]);
  const [current_page, set_current_page] = useState(
    Number(localStorage.getItem("offender_download_page")) || 1
  );

  const [search_key, set_search_key] = useState(
    localStorage.getItem("offender_download_search_key") || "name"
  );

  const [search_value, set_search_value] = useState(
    localStorage.getItem("offender_download_search") || ""
  );
  const [page_size, set_page_size] = useState(10);
  const [total_items, set_total_items] = useState(0);
  const [downloadModal, setDownloadModal] = useState(false);
const [downloadFileName, setDownloadFileName] = useState("");
const [selectedId, setSelectedId] = useState(null);



  const debounceRef = useRef(null);

  // ------------------- LIST API -------------------
  const LIST_API = async (
    page = current_page,
    per_page = page_size,
    key = search_key,
    value = search_value
  ) => {

    const FORM_DATA = new FormData();

    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", per_page);

    if (value) {
      FORM_DATA.append(key, value);
    }

    const API_CALL = await LIST_OFFENDER_REPORT(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data || []);
      set_current_page(API_CALL?.data?.current_page || page);
      set_total_items(API_CALL?.data?.total_rows || 0);
    }

    setLoader(false);
    set_pagination_loader(false);
  };

  const handleSearch = (e) => {

    const value = e.target.value;

    if (value && !search_value) {
      localStorage.setItem(
        "offender_download_last_search_page",
        current_page
      );
    }

    set_search_value(value);

    localStorage.setItem(
      "offender_download_search",
      value
    );

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {

      const pageToLoad = value
        ? 1
        : Number(
          localStorage.getItem(
            "offender_download_last_search_page"
          )
        ) || 1;

      set_current_page(pageToLoad);

      LIST_API(
        pageToLoad,
        page_size,
        search_key,
        value
      );

    }, 500);
  };

  // ------------------- DOWNLOAD -------------------
 const EXPORT_DOWNLOAD_REPORT_ACTION = async (id) => {
  try {
    if (!downloadFileName.trim()) {
      message.error("Please enter file name");
      return;
    }

    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);

    const API_CALL = await EXPORT_DOWNLOAD_REPORT(FORM_DATA);

    if (API_CALL?.data?.status && API_CALL?.data?.url) {
      const response = await fetch(API_CALL.data.url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;

      link.download = downloadFileName.endsWith(".xlsx")
        ? downloadFileName
        : `${downloadFileName}.xlsx`;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(blobUrl);

      setDownloadModal(false);
      setDownloadFileName("");

      message.success("Report downloaded successfully");
    }
  } catch (error) {
    console.error(error);
    message.error("Unable to download file");
  }
};

  //ya deleate kelia hai is pe kaam karna hai
  const DELETE_OFFENDER_REPORT = async (id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);

    try {
      const response = await DELETE_CAMPAIGN_OFFENDER_REPORT(FORM_DATA);
      if (response?.data?.status) {
        message.success("Campaign deleted successfully");
        LIST_API(); // refresh table
      } else {
        message.error("Failed to delete campaign");
      }
    } catch (err) {
      message.error("Something went wrong");
    }
  };

  useEffect(() => {
    LIST_API(
      Number(localStorage.getItem("offender_download_page")) || 1,
      page_size,
      localStorage.getItem("offender_download_search_key") || "name",
      localStorage.getItem("offender_download_search") || ""
    );
  }, []);
  // ------------------- TABLE COLUMNS -------------------
  const columns = [
    {
      title: "Created Date",
      render: (_, record) => (
        <span>{formatToIST(record.created_at)}</span>
      ),
    },
    {
      title: "Name",
      render: (_, record) => (
        <span>{record?.report_view?.name || "N/A"}</span>
      ),
    },
    {
      title: "Email",
      render: (_, record) => (
        <span>{record?.report_view?.email || "N/A"}</span>
      ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <>
         <Button
  onClick={() => {
    setSelectedId(record?.id);
    setDownloadFileName("");
    setDownloadModal(true);
  }}
  variant="solid"
  size="small"
  style={{
    marginRight: "12px",
    backgroundColor: "#1fa7a1",
    color: "#ffffff"
  }}
>
  <DownloadOutlined />
</Button>


          <Popconfirm
            title="Are you sure you want to delete this report?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => DELETE_OFFENDER_REPORT(record?.id)}
          >
            <Button
              variant="solid"
              color="danger"
              size="small"
            >
              <DeleteOutlined />
            </Button>
          </Popconfirm>

        </>
      ),
    },
  ];

  // ------------------- PAGINATION -------------------
  const onPageChange = (page) => {

    localStorage.setItem(
      "offender_download_page",
      page
    );

    set_pagination_loader(true);

    LIST_API(
      page,
      page_size,
      search_key,
      search_value
    );
  };

  const onPageSizeChange = (value) => {

    localStorage.setItem(
      "offender_download_page",
      1
    );

    set_current_page(1);
    set_page_size(value);

    LIST_API(
      1,
      value,
      search_key,
      search_value
    );
  };

  return (
    <div>
      <Row style={{ marginBottom: 20 }}>
        <Col span={20}>
          <Input
            value={search_value}
            addonBefore={
              <Select
                value={search_key}
                style={{ width: 80 }}
                onChange={(v) => {

                  set_search_key(v);

                  localStorage.setItem(
                    "offender_download_search_key",
                    v
                  );

                  localStorage.setItem(
                    "offender_download_page",
                    1
                  );

                  set_current_page(1);

                  LIST_API(
                    1,
                    page_size,
                    v,
                    search_value
                  );
                }}
              >
                <Option value="name">Name</Option>
                <Option value="email">Email</Option>
              </Select>
            }
            placeholder={`Search by ${search_key}`}
            onChange={handleSearch}
            size="large"
          />
        </Col>
      </Row>

      {/* TABLE */}
      {loader ? (
        <CulsightPageLoader />
      ) : pagination_loader ? (
        <div style={{ textAlign: "center", padding: 60 }}>
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={table_data}
          pagination={false}
          rowKey="id"
        />
      )}

      {/* PAGINATION */}
      {total_items > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 15,
            marginTop: 20,
          }}
        >
          <Pagination
            current={current_page}
            pageSize={page_size}
            total={total_items}
            onChange={onPageChange}
            showSizeChanger={false}
          />

          <Select
            value={page_size}
            onChange={onPageSizeChange}
            style={{ width: 120 }}
            options={[
              { value: 10, label: "10 / page" },
              { value: 20, label: "20 / page" },
              { value: 50, label: "50 / page" },
              { value: 100, label: "100 / page" },
            ]}
          />
        </div>
      )}
      <Modal
  title="Download Report"
  open={downloadModal}
  onCancel={() => {
    setDownloadModal(false);
    setDownloadFileName("");
  }}
  onOk={() => EXPORT_DOWNLOAD_REPORT_ACTION(selectedId)}
>
  <Input
    placeholder="Enter file name"
    value={downloadFileName}
    onChange={(e) => setDownloadFileName(e.target.value)}
  />
</Modal>
    </div>
  );
}

export default OffenderDownload;
